import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=b39ecedc&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=b39ecedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ecedc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39ecedc')) {
      api.createRecord('b39ecedc', component.options)
    } else {
      api.reload('b39ecedc', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=b39ecedc&scoped=true&", function () {
      api.rerender('b39ecedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnlinePrinting/components/Classification.vue"
export default component.exports